import React, { useMemo, forwardRef } from 'react';

import { IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

const LoadingIconButtonWithTooltip = forwardRef(
  ({ children, loading = false, title, tooltipProps = {}, ...iconButtonProps }, ref) => {
    const modifiedTooltipProps = useMemo(
      () => ({
        ...tooltipProps,
      }),
      [tooltipProps]
    );

    return iconButtonProps.disabled ? (
      <Tooltip title={title} {...modifiedTooltipProps}>
        <div>
          <IconButton disabled aria-label={title} {...iconButtonProps} ref={ref}>
            {children}
          </IconButton>
        </div>
      </Tooltip>
    ) : (
      <Tooltip title={title} {...modifiedTooltipProps}>
        <div>
          <IconButton aria-label={title} {...iconButtonProps} ref={ref}>
            {children}
          </IconButton>
        </div>
      </Tooltip>
    );
  }
);

LoadingIconButtonWithTooltip.displayName = 'LoadingIconButtonWithTooltip';

LoadingIconButtonWithTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
  title: PropTypes.string.isRequired,
  tooltipProps: PropTypes.object,
};

export default LoadingIconButtonWithTooltip;
